module.exports = __webpack_public_path__ + "img/pine_lab-icon.4bdd612c.png";